// Numery inwentarzowe dla kilku sztuk dodawanych naraz (24.10.2026). Czyste, bez React.
//
// Z numeru pierwszej sztuki powstaje seria: liczba na końcu rośnie o 1, a jej szerokość z zerami
// zostaje („NART-008” → NART-008, NART-009, NART-010). Gdy liczba przekroczy szerokość, po prostu
// się wydłuża (99 → 100). Numer bez liczby na końcu dostaje przyrostek „-01”, „-02”…, z szerokością
// wystarczającą dla całej serii; pierwsza sztuka też go dostaje, żeby seria była jednolita.
// Pusty numer = sztuki bez numerów (serwer zapisuje NULL, etykieta dostaje kod systemowy).

export const MAKS_SZTUK = 100;

export function kolejneNumery(pierwszy, ile) {
  const n = Math.max(0, Math.floor(Number(ile) || 0));
  const start = String(pierwszy ?? '').trim();
  if (!start) return Array.from({ length: n }, () => '');

  const m = start.match(/^(.*?)(\d+)$/);
  if (m) {
    const [, przedrostek, cyfry] = m;
    const od = BigInt(cyfry);
    return Array.from({ length: n }, (_, i) => `${przedrostek}${(od + BigInt(i)).toString().padStart(cyfry.length, '0')}`);
  }
  const szerokosc = Math.max(2, String(n).length);
  return Array.from({ length: n }, (_, i) => `${start}-${String(i + 1).padStart(szerokosc, '0')}`);
}

/** Skrót serii do podglądu: do `pokaz` pierwszych, potem „…” i ostatni. */
export function skrotSerii(numery, pokaz = 3) {
  const lista = Array.isArray(numery) ? numery : [];
  if (lista.length <= pokaz + 1) return { poczatek: lista, ostatni: null, pominieto: 0 };
  return { poczatek: lista.slice(0, pokaz), ostatni: lista[lista.length - 1], pominieto: lista.length - pokaz - 1 };
}

/** Liczba sztuk z pola: całkowita 1..MAKS_SZTUK, inaczej `null` (pole pokazuje błąd). */
export function iloscZPola(tekst) {
  const s = String(tekst ?? '').trim();
  if (!/^\d+$/.test(s)) return null;
  const n = Number(s);
  return n >= 1 && n <= MAKS_SZTUK ? n : null;
}
